<template>
  <div>
    <label v-if="label" class="label" data-type-cy="text" data-value-cy="input_label">{{label}} <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i></label>
    <div class="field" :class="{'has-addons is-radiusless':icon}">
      <div class="control is-expanded"
        :class="{'has-icons-right': hasIconRightC,
                  'has-icons-left': hasIconLeftC,
                  'has-incrementations': hasIncrementations}"
      >
        <span v-if="iconLeftInset !== false" class="icon is-small"><i :class="iconLeftInset"></i></span>
        <input v-if="number" :type="inputType" @change="update" @input="update" :name="name" :id="name" class="input is-radiusless"
              :class="{'is-danger': provocatedError || hasError, [classes]: true}" :max="max" :min="min"
              :disabled="disabled" step="any"
              :placeholder="placeholder" v-model.number="val" data-type-cy="input" data-value-cy="field">
        <input v-else :type="inputType" @change="update" @input="update" :name="name" :id="name" class="input is-radiusless"
               :class="{'is-danger': provocatedError || hasError, [classes]: true}"
               :disabled="disabled"
              :placeholder="placeholder" v-model="val" data-type-cy="input" data-value-cy="field">
        <div v-if="hasIncrementations" class="incrementation">
          <a href="#" @click="incrementUp()" class="incrementation-btn"><i class="fas fa-chevron-up"></i></a>
          <a href="#" @click="incrementDown()" class="incrementation-btn"><i class="fas fa-chevron-down"></i></a>
        </div>
        <span v-if="provocatedError || hasError"
          class="icon is-small"
          :class="{'is-left': hasIncrementations, 'is-right': !hasIncrementations}"
        >
          <i class="fas fa-exclamation-triangle" data-type-cy="icon" data-value-cy="error"></i>
        </span>
        <slot name="icon-right-secondaire"></slot>
      </div>
      <slot v-if="icon"></slot>
    </div>
    <p v-if="provocatedError || firstError" class="help is-danger" data-type-cy="text" data-value-cy="error">{{provocatedMessage || firstError}}</p>
  </div>
</template>

<script>
  export default {
    name: 'VInput',
    data () {
      return {
        val: null,
        numberVal: null
      }
    },
    props: {
      inputType: {
        type: String,
        default: 'text'
      },
      classes: {
        type: [String, Array],
        required: false,
        default: ''
      },
      model: {
        required: true
      },
      icon: {
        type: String,
        required: false
      },
      label: {
        type: String,
        required: false
      },
      name: {
        type: String,
        default: 'defaultInputName'
      },
      errorsBag: {
        required: true
      },
      placeholder: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      number: {
        type: Boolean,
        default: false
      },
      min: {
        type: [Number, String]
      },
      max: {
        type: [Number, String]
      },
      iconLeftInset: {
        type: [String, Boolean],
        required: false,
        default: false
      },
      fromFlux: Boolean,
      provocatedError: Boolean,
      provocatedMessage: String,
      hasIncrementations: {
        type: Boolean,
        required: false,
        default: false
      },
      incrementationsPas: {
        type: Number,
        required: false,
        default: 1
      }
    },
    computed: {
      firstError () {
        return this.errorsBag.collect(this.name)[0]
      },
      hasError () {
        return this.errorsBag.has(this.name)
      },
      hasIconLeftC () {
        if (this.hasIncrementations && (this.provocatedError || this.hasError)) {
          return true
        } else if (this.iconLeftInset) {
          return true
        } else {
          return false
        }
      },
      hasIconRightC () {
        if (!this.hasIncrementations && (this.provocatedError || this.hasError)) {
          return true
        } else {
          return false
        }
      }
    },
    watch: {
      model (to) {
        this.val = to
      },
      val (to) {
        if (this.max && to > this.max) this.val = this.max
        else this.val = to
      }
    },
    methods: {
      update () {
        if (this.min) {
          if (this.val < this.min && this.val !== '') this.val = this.min
        }
        this.$emit('input', this.val)
      },
      incrementUp () {
        this.val = Math.round((this.val + this.incrementationsPas) * 10) / 10
        this.$emit('input', this.val)
      },
      incrementDown () {
        this.val = Math.round((this.val - this.incrementationsPas) * 10) / 10
        this.$emit('input', this.val)
      }
    },
    created () {
      this.val = this.model
      this.numberVal = this.model
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/utils/VInput.vue